import * as React from "react";
import IAuthenticationResponse from "../../core/contracts/IAuthenticationResponse";
import { EVENT_FORCE_ROUTE_CHANGE, EVENT_TOKEN_RENEW_TICK } from "../../Events";
import { DO_RENEW_AUTH_TOKEN } from "../../Fedx";
import { SessionCache } from "../../helpers/cache";
import { withHubx, withHubxType } from "../../HubX";

class TokenRenewer extends React.Component<withHubxType> {
  constructor(props: withHubxType) {
    super(props);

    this.silentlyRenewToken = this.silentlyRenewToken.bind(this);
    this.clearCacheAndRedirect = this.clearCacheAndRedirect.bind(this);

    props.attach(EVENT_TOKEN_RENEW_TICK, this.silentlyRenewToken);
  }

  clearCacheAndRedirect() {
    const cache = new SessionCache();
    cache.clear();
    this.props.notify(EVENT_FORCE_ROUTE_CHANGE, "/login/");
  }

  // TODO - test token
  async silentlyRenewToken() {
    // eslint-disable-next-line no-console
    console.info(`/*TRYING TO RENEW TOKEN!*/ → ${new Date().toLocaleString()}`);
    try {
      const APIResponse: IAuthenticationResponse = await this.props.request(DO_RENEW_AUTH_TOKEN);
      const { token } = APIResponse;

      if (token) {
        const cache = new SessionCache();
        cache.set("bearer-token", token);
        // eslint-disable-next-line no-console
        console.info(`/*TOKEN RENEWED WITH SUCCESS!*/`);
      } else {
        this.clearCacheAndRedirect();
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("silentlyRenewToken -> error", error);
      this.clearCacheAndRedirect();
    }
  }

  render() {
    return null;
  }
}

export default withHubx(TokenRenewer);
